// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LBRm","newExpiryDate":"styles_newExpiryDate__1pn3S","footer":"styles_footer__1xStz"};